import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import '../styles/main.scss';
import expandableRows from './expandableRows';
import bindEvents from './events';
import { startTabs } from './tabs';

(($) => {
  $(document).ready(() => {
    // ga('create', 'UA-296593-9', 'auto');

    startTabs();
    bindEvents();
    expandableRows();
  });
})(jQuery);

/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/main.js